//* Libraries imports
import { api } from "../api";

//* Types imports
import type { ApiResponse, ApiError } from "@/types/api";
import type {
  CreatePaymentAsaasDTO,
  CreateCreditCardPaymentAsaasDTO,
  PaymentResponseAsaasDTO,
  PixResponseAsaasDTO,
} from "@/schemas/asaas/payment";

class PaymentAsaasService {
  private baseUrl: string;

  constructor() {
    this.baseUrl = `${api.API_URL}/asaas/payments`;
  }

  async create(
    data: CreatePaymentAsaasDTO | CreateCreditCardPaymentAsaasDTO,
  ): Promise<ApiResponse<PaymentResponseAsaasDTO> | ApiError> {
    return await api.request<PaymentResponseAsaasDTO>(this.baseUrl, {
      method: "POST",
      body: JSON.stringify(data),
    });
  }

  async getPixQrCode(
    paymentId: string,
  ): Promise<ApiResponse<PixResponseAsaasDTO> | ApiError> {
    return await api.request<PixResponseAsaasDTO>(
      `${this.baseUrl}/${paymentId}/pix-qr-code`,
      {
        method: "GET",
      },
    );
  }
}

export const paymentAsaasService = new PaymentAsaasService();
